import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, normalizeClass as _normalizeClass, withDirectives as _withDirectives, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "m-auto px-8 md:px-20" }
const _hoisted_2 = { class: "max-w-screen-2xl m-auto" }
const _hoisted_3 = { class: "font-bold" }
const _hoisted_4 = { class: "pt-5 flex flex-col" }
const _hoisted_5 = { class: "flex pt-3 justify-end" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MultiselectOption = _resolveComponent("MultiselectOption")!
  const _component_VueMultiselect = _resolveComponent("VueMultiselect")!
  const _component_Field = _resolveComponent("Field")!
  const _component_NextButton = _resolveComponent("NextButton")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "py-5 text-2xl font-bold" }, " Dettaglio azienda gruppo ", -1)),
      _withDirectives(_createElementVNode("div", {
        class: _normalizeClass([[_ctx.esito ? 'bg-next-bri' : 'bg-next-orange'], "text-white p-3 mb-3 flex justify-between items-center"])
      }, [
        _createTextVNode(_toDisplayString(_ctx.response_message) + " ", 1),
        _createElementVNode("i", {
          class: "icon-x cursor-pointer",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.response_message = ''))
        })
      ], 2), [
        [_vShow, _ctx.response_message.length]
      ]),
      _createElementVNode("p", null, [
        _cache[2] || (_cache[2] = _createTextVNode("Azienda gruppo: ")),
        _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.azienda.nome), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createVNode(_component_Field, { field_name: "Business unit" }, {
          default: _withCtx(() => [
            _createVNode(_component_VueMultiselect, {
              modelValue: _ctx.buAutocomplete.selection,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.buAutocomplete.selection) = $event)),
              options: _ctx.buAutocomplete.options,
              placeholder: "Business unit",
              class: "next-vue-multiselect",
              "track-by": "id",
              label: "nome",
              multiple: true,
              selectLabel: "",
              deselectLabel: "",
              selectedLabel: "",
              "internal-search": false,
              "close-on-select": false,
              "clear-on-select": true,
              onSearchChange: _ctx.buAutocomplete.search
            }, {
              tag: _withCtx(({option, remove}) => [
                _createVNode(_component_MultiselectOption, {
                  onRemove: ($event: any) => (remove(option))
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(option.nome), 1)
                  ]),
                  _: 2
                }, 1032, ["onRemove"])
              ]),
              _: 1
            }, 8, ["modelValue", "options", "onSearchChange"])
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_NextButton, {
          class: "px-3 py-2",
          onClick: _ctx.save
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [
            _createTextVNode("Salva")
          ])),
          _: 1
        }, 8, ["onClick"])
      ])
    ])
  ]))
}